import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
    selector: 'vsf-form-field-label',
    templateUrl: './form-field-label.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormFieldLabelComponent {
    /** i18n key passed to translate pipe */
    @Input() labelKey = '';
    @Input() forId = '';
    @Input() required = false;
    @Input() optional = false;
    /** Tailwind / utility classes for the label element */
    @Input() labelClass = 'block text-sm font-medium text-gray-700';
}
